/* Gros Chien — Suivi de commande (2026-10-11).
   Données : commandes du client connecté (Liquid), ou lien d'e-mail ?n=&c=&d=&e=, ou numéro saisi.
   Le détail du transporteur s'affiche dans un cadre, dans la page. */
(function () {
  'use strict';
  function init() {
    var root = document.getElementById('gcs');
    if (!root || root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');

    var cfg = {}, orders = [];
    try { cfg = JSON.parse(document.getElementById('gcs-config').textContent) || {}; } catch (e) {}
    try { var oe = document.getElementById('gcs-orders'); if (oe) orders = JSON.parse(oe.textContent) || []; } catch (e) {}
    var MIN = cfg.delivMin || 14, MAX = cfg.delivMax || 21;
    var CARRIER = cfg.carrier || '', CONTACT = cfg.contact || '/pages/formulaire-de-contact';
    var dogTpl = document.getElementById('gcs-dog-tpl');
    var DOG = dogTpl ? dogTpl.innerHTML : '';

    var form = document.getElementById('gcs-form'), input = document.getElementById('gcs-input'),
        hint = document.getElementById('gcs-hint'), result = document.getElementById('gcs-result'),
        box = document.getElementById('gcs-orders-box'), list = document.getElementById('gcs-orders-list');

    var MONTHS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
    var DAYS = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
    function pd(s) { var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s || ''); return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null; }
    function fd(d, withDay) { return (withDay ? DAYS[d.getDay()] + ' ' : '') + (d.getDate() === 1 ? '1er' : d.getDate()) + ' ' + MONTHS[d.getMonth()]; }
    function add(d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }
    function days(a, b) { return Math.round((b - a) / 864e5); }
    function today() { var n = new Date(); return new Date(n.getFullYear(), n.getMonth(), n.getDate()); }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function clean(s) { return String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
    function isOrderNo(s) { return /^(GC)?\d{3,9}$/.test(s); }
    function isTrack(s) { return /^[A-Z0-9]{9,34}$/.test(s) && /\d{6,}/.test(s) && !isOrderNo(s); }
    function say(t) { if (hint) hint.textContent = t || ''; }
    function plural(n, w) { return n + ' ' + w + (n > 1 ? 's' : ''); }

    /* --- modèle : {name, date, ships:[{d,n}], cancelled} --- */
    function modelFromOrder(o) {
      var seen = {}, ships = [];
      (o.ships || []).forEach(function (s) { var k = (s.n || '') + '|' + (s.d || ''); if (!seen[k]) { seen[k] = 1; ships.push({ d: s.d, n: s.n ? clean(s.n) : '' }); } });
      return { name: o.name, date: o.date, ships: ships, cancelled: !!o.cancelled };
    }

    function compute(m, idx) {
      var now = today(), d = pd(m.date), ship = m.ships[idx] || null, e = ship ? pd(ship.d) : null, r = { step: 0, f: 0, idle: false };
      if (m.cancelled) { r.title = 'Commande annulée'; r.sub = 'Cette commande a été annulée. Une question ? Écrivez-nous.'; r.idle = true; r.off = true; return r; }
      if (!d && !e) { r.idle = true; r.title = 'Colis en route'; r.sub = 'Votre colis est expédié. Comptez 2 à 3 semaines entre la commande et la livraison.'; return r; }
      if (d) { r.from = add(d, MIN); r.to = add(d, MAX); }
      if (!e) {
        r.step = 1; r.f = 0.125; r.title = 'En préparation';
        r.sub = 'Votre commande est enregistrée. Vous recevrez un e-mail avec le numéro de suivi dès l’expédition.';
        return r;
      }
      var end = r.to || add(e, MAX), span = Math.max(1, days(e, end)), t = Math.min(1, Math.max(0, days(e, now) / span));
      r.since = Math.max(0, days(e, now));
      r.f = 0.25 + t * 0.7;
      r.step = r.f >= 0.75 ? 3 : 2;
      r.late = days(end, now) > 3;
      if (r.late) { r.title = 'Délai habituel dépassé'; r.sub = 'Si vous n’avez pas reçu votre colis, écrivez-nous : nous lançons une recherche tout de suite.'; }
      else if (r.step === 3) { r.title = 'Dernière ligne droite'; r.sub = 'Votre colis devrait être chez le transporteur local ou tout près.'; }
      else { r.title = 'En route vers vous'; r.sub = r.since === 0 ? 'Votre colis vient de partir.' : 'Votre colis voyage depuis ' + plural(r.since, 'jour') + '.'; }
      return r;
    }

    function render(m, idx) {
      idx = idx || 0;
      var r = compute(m, idx), ship = m.ships[idx] || null, num = ship && ship.n ? ship.n : '', d = pd(m.date), e = ship ? pd(ship.d) : null;
      var labels = ['Reçue', 'Expédiée', 'En route', 'Transporteur', 'Livrée'];
      var subs = [d ? fd(d) : '', e ? fd(e) : '', '', '', r.to && !r.off ? 'vers le ' + fd(r.to) : ''];
      var h = '';
      h += '<div class="gcs-res__head"><div>';
      h += '<h2 class="gcs-res__status">' + esc(r.title) + '</h2>';
      h += '<p class="gcs-res__sub">' + (m.name ? '<b>Commande ' + esc(m.name) + '</b> · ' : '') + esc(r.sub) + '</p>';
      h += '</div>';
      h += '</div>';
      if (m.ships.length > 1) {
        h += '<div class="gcs-parcels" role="tablist" aria-label="Colis de la commande">';
        m.ships.forEach(function (s, i) { h += '<button type="button" role="tab" aria-selected="' + (i === idx) + '" class="' + (i === idx ? 'is-on' : '') + '" data-parcel="' + i + '">Colis ' + (i + 1) + '</button>'; });
        h += '</div>';
      }
      h += '<div class="gcs-trail' + (r.idle ? ' gcs-trail--idle' : '') + '" style="--f:0"><div class="gcs-trail__line"><i></i></div><div class="gcs-trail__dog" aria-hidden="true">' + DOG + '</div><ol class="gcs-trail__stops">';
      labels.forEach(function (l, i) {
        var cls = r.idle ? '' : (i < r.step ? 'is-done' : (i === r.step ? 'is-now' : ''));
        h += '<li class="' + cls + '"><b>' + l + '</b>' + (subs[i] ? '<small>' + esc(subs[i]) + '</small>' : '') + '</li>';
      });
      h += '</ol></div>';
      if (!r.idle) h += '<p class="gcs-trail__note">Position estimée d’après les dates réelles de votre commande.</p>';

      var facts = '';
      if (d) facts += '<div class="gcs-fact"><span>Commande passée</span><strong>' + fd(d, true) + '</strong></div>';
      if (e) facts += '<div class="gcs-fact"><span>Colis expédié</span><strong>' + fd(e, true) + '</strong></div>';
      if (e && !r.off) facts += '<div class="gcs-fact"><span>En route depuis</span><strong>' + plural(r.since, 'jour') + '</strong></div>';
      if (r.from && !r.off) facts += '<div class="gcs-fact gcs-fact--key"><span>Livraison estimée</span><strong>' + fd(r.from) + ' → ' + fd(r.to) + '</strong></div>';
      if (facts) h += '<div class="gcs-facts">' + facts + '</div>';

      // Point d'extension : quand une source de suivi filtrée sera branchée (cfg.events), ses étapes s'afficheront ici.
      h += '<div class="gcs-help"><p>' + (r.late ? '<b>Besoin d’aide ?</b> Donnez-nous votre numéro de commande, on s’en occupe.' : 'Une question sur cette commande ? Écrivez-nous, on s’en occupe.') + '</p><a href="' + esc(CONTACT) + '">Nous écrire</a></div>';

      result.innerHTML = h;
      result.hidden = false;
      result._m = m;
      var trail = result.querySelector('.gcs-trail');
      requestAnimationFrame(function () { requestAnimationFrame(function () { if (trail) trail.style.setProperty('--f', String(r.idle ? 0 : r.f)); }); });
    }

    function show(m, idx, scroll) {
      render(m, idx);
      if (scroll !== false && result.scrollIntoView) { try { result.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { result.scrollIntoView(); } }
    }

    result.addEventListener('click', function (ev) {
      var t = ev.target;
      if (t.getAttribute && t.getAttribute('data-parcel') !== null && result._m) { render(result._m, +t.getAttribute('data-parcel')); return; }
      var c = t.getAttribute && t.getAttribute('data-copy');
      if (c) {
        var done = function () { t.textContent = 'Copié'; setTimeout(function () { t.textContent = 'Copier'; }, 1600); };
        try { navigator.clipboard.writeText(c).then(done, function () {}); } catch (e) {}
      }
    });

    /* --- commandes du client connecté --- */
    if (orders.length && box && list) {
      var h = '';
      orders.forEach(function (o, i) {
        var m = modelFromOrder(o), shipped = m.ships.length > 0;
        var st = o.cancelled ? ['Annulée', 'off'] : (shipped ? ['Expédiée', 'go'] : ['En préparation', 'prep']);
        var d = pd(o.date);
        h += '<button type="button" class="gcs-oc" data-order="' + i + '"><span class="gcs-oc__top"><span class="gcs-oc__name">' + esc(o.name) + '</span><span class="gcs-oc__date">' + (d ? fd(d, true) : '') + '</span></span><span class="gcs-oc__imgs">';
        (o.items || []).forEach(function (it) { h += it.img ? '<img src="' + esc(it.img) + '" alt="' + esc(it.t) + '" width="46" height="46" loading="lazy">' : '<span></span>'; });
        if (o.count > (o.items || []).length) h += '<span>+' + (o.count - o.items.length) + '</span>';
        h += '</span><span class="gcs-oc__st gcs-oc__st--' + st[1] + '">' + st[0] + (shipped && m.ships.length > 1 ? ' · ' + m.ships.length + ' colis' : '') + '</span></button>';
      });
      list.innerHTML = h;
      box.hidden = false;
      list.addEventListener('click', function (ev) {
        var b = ev.target.closest ? ev.target.closest('[data-order]') : null; if (!b) return;
        [].forEach.call(list.querySelectorAll('.gcs-oc'), function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on'); say('');
        show(modelFromOrder(orders[+b.getAttribute('data-order')]), 0);
      });
    }

    function findOrder(q) {
      for (var i = 0; i < orders.length; i++) {
        var o = orders[i], n = clean(o.name);
        if (n === q || n === 'GC' + q || n.replace(/^GC/, '') === q) return modelFromOrder(o);
        var m = modelFromOrder(o);
        for (var j = 0; j < m.ships.length; j++) if (m.ships[j].n && m.ships[j].n === q) { m._idx = j; return m; }
      }
      return null;
    }

    function lookup(raw, scroll) {
      var q = clean(raw);
      if (!q) { say('Entrez votre numéro de commande.'); return; }
      var m = findOrder(q);
      if (m) { say(''); show(m, m._idx || 0, scroll); return; }
      say('Cette commande n’est pas dans votre compte. Vérifiez le numéro dans votre e-mail de confirmation, ou écrivez-nous.');
    }

    if (form) form.addEventListener('submit', function (ev) { ev.preventDefault(); lookup(input.value); });

    /* --- arrivée depuis un e-mail : ?n=NUM[,NUM]&c=GC123&d=AAAA-MM-JJ&e=AAAA-MM-JJ --- */
    var qs = {};
    location.search.replace(/^\?/, '').split('&').forEach(function (p) { var kv = p.split('='); if (kv[0]) { try { qs[kv[0]] = decodeURIComponent((kv[1] || '').replace(/\+/g, ' ')); } catch (e) {} } });
    var cOk = /^#?[A-Za-z]{0,4}\d{3,9}$/.test(qs.c || '') ? qs.c : '';
    if (qs.n || cOk || pd(qs.d) || pd(qs.e)) {
      // le lien d'un e-mail suffit, même sans numéro de suivi (e-mail de test, colis pas encore scanné)
      var nums = (qs.n || '').split(',').map(clean).filter(isTrack).slice(0, 6);
      var known = nums.length ? findOrder(nums[0]) : (cOk ? findOrder(clean(cOk)) : null);
      if (known) show(known, known._idx || 0, false);
      else if (nums.length || cOk || pd(qs.d) || pd(qs.e)) {
        var ships = nums.length ? nums.map(function (n) { return { d: pd(qs.e) ? qs.e : '', n: n }; }) : (pd(qs.e) ? [{ d: qs.e, n: '' }] : []);
        if (!ships.length && !pd(qs.d)) ships = [{ d: '', n: '' }];
        show({ name: cOk, date: pd(qs.d) ? qs.d : '', ships: ships, cancelled: false }, 0, false);
      }
    } else if (orders.length === 1) {
      show(modelFromOrder(orders[0]), 0, false);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  if (window.InstantClick && window.InstantClick.on) { try { window.InstantClick.on('change', init); } catch (e) {} }
})();
